<template>
    <div class="parent">
        <banner v-bind:bannerObj="bannerObj"></banner>
        <div class="container">
            <div class="content">
                <div class="curmbsLink">
                    <router-link to="/products">产品与服务</router-link>
                    <span> > </span>
                    <span>电商解决方案</span>
                </div>
                <div class="address">
                    <div>
                        <b>GET</b>
                        <span>电商解决方案</span>
                        <p>全方位电商解决方案：为您打造专属的互联网商城（独立品牌），同时提供法律、保险、物流、引流等电商增值服务，让您专心做电商业务。 </p>
                    </div>
                </div>
                <div class="textWrap">
                    <span>基本介绍</span>
                    <p>我们为您提供以下服务：</p>
                    <p>1、打造互联网商城</p>
                    <p>（1）为制造业企业提供免费的电商平台</p>
                    <p>（2）针对您的需求提供ERP系统对接实现同步库存管理</p>
                    <p>（3）为您提供各个国家当地收款服务</p>
                    <p>（4）为您安全把企业的销售额清算至国内，并以优惠价格结汇</p>
                    <p>（5）通过我们的金融伙伴为您提供融资等金融方案</p>
                    <p>2、电商增值服务</p>
                    <p>（1）法律服务：为您提供国内和国际商标、专利、版权的注册、转让及诉讼等专业服务。还可以提供高新技术企业认定、电商法律咨询、法律培训等创新服务。</p>
                    <p>（2）保险服务：针对跨境订单交易、破损、运费等，为您推荐相应的保险服务，您可根据实际情况配合订单选择。</p>
                    <p>（3）物流服务：借助我们合作的跨境物流公司，为您推荐优质的跨境物流服务，您可多方面比价选择更适合、更优质的跨境物流服务。</p>
                    <p>（4）引流服务：针对企业需求，需要市场额外推广时，为企业推荐其他引流方法，如：搜索推广流量google、社交推广流量Facebook等。</p>
                </div>
            </div>
        </div>
        <footer>
            <footContent></footContent>
        </footer>
    </div>
</template>

<style lang="scss">
    .parent{
        background-color: #fff;
        .container {
            width: 1200px;
            margin: 0 auto;
            padding-top: 64px;
        }
        .content { margin-bottom: 80px; }
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3); }
            a:hover { color: #323232; }
        }
        .address {
            width: 100%;
            height: 450px;
            margin-bottom: 60px;
            background: url('../assets/images/photograph.png') no-repeat;
            background-size: auto 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: center;
            position: relative;
            > div:after {
                content: '';
                position: absolute;
                bottom: -2px;
                right: 50px;
                z-index: 1;
                width: 162px;
                height: 70px;
                background: #FEBD00;
                box-shadow: 0 0 50px rgba(0,0,0,0.2);
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
            }
            > div {
                width: 717px;
                height: 364px;
                background: #fff;
                border-top-left-radius: 45px;
                border-bottom-right-radius: 45px;
                box-shadow: 0 0 40px rgba(0,0,0,0.15);
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
                align-items: center;
                b, span, p { width: 80%; }
                b {
                    display: block;
                    font-size: 48px;
                    font-weight: 800;
                    margin-bottom: 20px;
                }
                span {
                    display: block;
                    font-size: 30px;
                    font-weight: bold;
                    text-indent: 40px;
                    position: relative;
                    margin-bottom: 40px;
                }
                span:after {
                    content: '';
                    width: 12px;
                    height: 12px;
                    background: #FEBD00;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    z-index: 1;
                }
                p { font-size: 20px; color: #323232; line-height: 30px;}
            }
        }
        .textWrap {
            span {
                display: block;
                font-size: 30px;
                text-indent: 40px;
                margin-bottom: 40px;
                position: relative;
            }
            span:after {
                content: '';
                width: 18px;
                height: 18px;
                background: #FEBD00;
                position: absolute;
                left: 0;
                top: 10px;
                z-index: 2;
            }
            span:before {
                content: '';
                width: 18px;
                height: 18px;
                background: #cbcbcb;
                position: absolute;
                left: 6px;
                top: 4px;
                z-index: 1;
            }
            p { line-height: 30px; }
        }
    }

</style>


<script>
import store from '../vuex'
import DetailBanner from '../components/DetailBanner'
import FootContent from "../components/FootContent.vue";
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/products.png'),
            text: 'PRODUCTS & SOLUTIONS',
        }
      }
  },
  components:{
    'banner': DetailBanner,
    'footContent': FootContent,
  },
  store,
}
</script>

